import React, { useContext } from "react";
// import icons
import {
  ImLinkedin,
  ImGithub,
  ImGoogle2,
  ImInstagram,
  ImTwitter,
} from "react-icons/im";
// import cursor context
import { CursorContext } from "../context/CursorContext";

const Socials = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <div
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
      className="hidden xl:flex ml-24 size-4"
    >
      <ul className=" flex gap-x-5">
        <li>
          <a
            href="https://www.linkedin.com/in/ankitakash07/"
            target="_blank"
            rel="noreferrer"
          >
            <ImLinkedin />
          </a>
        </li>
        <li>
          <a
            href="https://github.com/ankit-akash"
            target="_blank"
            rel="noreferrer"
          >
            <ImGithub />
          </a>
        </li>
        <li>
          <a
            href="http://www.instagram.com/ankitakash_"
            target="_blank"
            rel="noreferrer"
          >
            <ImInstagram />
          </a>
        </li>
        <li>
          <a
            href="https://developers.google.com/profile/u/ankitakash"
            target="_blank"
            rel="noreferrer"
          >
            <ImGoogle2 />
          </a>
        </li>
        <li>
          <a
            href="https://twitter.com/ankitakash_"
            target="_blank"
            rel="noreferrer"
          >
            <ImTwitter />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Socials;
